const HistoryLogEventType = {
  BUDGET_CHANGES : "BUDGET_CHANGES",
  PRICING_CHANGES_BY_RECOMMENDATION : "PRICING_CHANGES_BY_RECOMMENDATION",
  PRICING_CHANGES_BY_SYNCED : "PRICING_CHANGES_BY_SYNCED",
};

module.exports = Object.freeze(HistoryLogEventType);